module.exports = __webpack_public_path__ + "img/overview-stocks.99801aa6.svg";